module.exports = __webpack_public_path__ + "static/services__hero__graphic-cea095fc2cbc96177ff863eb6446a1fb.svg";